module.exports = __webpack_public_path__ + "media/images/icon_list/mail-9eca526bb0cbd380a31d26f9f57bfa9e.svg";